import { REFRESH_TOKEN } from '../../graphql/authGraphQL';
import { Variables } from '../../configs/appConfigs';
import LocalStorageService from '../../helpers/localStorageService';
import FetchError from './FetchError';

const handleRefreshToken = async () => {
  const res = await fetch(process.env.TV_AUTH_GRAPHQL_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-source-p': process.env.X_SOURCE_P,
      did: LocalStorageService.get(Variables.did),
      rtk: LocalStorageService.get(Variables.refreshToken),
    },
    body: JSON.stringify({
      query: REFRESH_TOKEN,
      variables: {},
    }),
  });

  const resJson = await res.json();

  if (!res.ok) {
    if (res.status === 422) {
      LocalStorageService.delete(Variables.did);
      window.location.reload();
    }
    throw new FetchError(res.status, resJson);
  }
  if (resJson.errors?.length > 0) {
    throw new FetchError(resJson.errors[0].statusCode, resJson.errors[0]);
  }
  return resJson;
};

export default handleRefreshToken;
